export default __webpack_public_path__ + "assets/apple-icon-120x120.72d10e64dbe7a88028581ef58b0917a0.png";